import { compact } from '@direct-frontend/stdlib';
import { CHARACTERISTIC_COLORS_SEARCH_PARAM_NAME_ACTIVE_TAB_MAP } from '#shared/lib/routes';
import { checkIsNotLiteStore } from '#shared/lib/storeInfo';

type CharacteristicsTabMap = typeof CHARACTERISTIC_COLORS_SEARCH_PARAM_NAME_ACTIVE_TAB_MAP;

export type CharacteristicsTabKey = CharacteristicsTabMap[keyof CharacteristicsTabMap];

export type CharacteristicsTabItem = {
    key: CharacteristicsTabKey;
    title: string;
};

export const getCharacteristicsTabItems = (): CharacteristicsTabItem[] =>
    compact([
        { key: CHARACTERISTIC_COLORS_SEARCH_PARAM_NAME_ACTIVE_TAB_MAP.ACTIVE, title: 'Активные' },
        checkIsNotLiteStore()
            ? { key: CHARACTERISTIC_COLORS_SEARCH_PARAM_NAME_ACTIVE_TAB_MAP.GROUPS, title: 'Группы' }
            : undefined,
        { key: CHARACTERISTIC_COLORS_SEARCH_PARAM_NAME_ACTIVE_TAB_MAP.COLORS, title: 'Цвета' },
        { key: CHARACTERISTIC_COLORS_SEARCH_PARAM_NAME_ACTIVE_TAB_MAP.ARCHIVE, title: 'Архив' },
    ]);
